jQuery(document).ready(function ($) {
  "use strict";

  function initTooltip($scope) {
    var $targets = $scope ? $scope.find('[data-thha-tooltip="true"]') : $('[data-thha-tooltip="true"]');

    // Add helper class to target elements to style them (like cursor helper)
    $targets.each(function () {
      var $target = $(this);
      
      // Cleanup any pre-existing event bindings to prevent duplicate handlers
      $target.off('.thhaTooltip');

      var trigger = $target.attr('data-thha-tooltip-trigger') || 'hover';
      var activeTooltip = null;

      function createTooltip() {
        var contentType = $target.attr('data-thha-tooltip-content-type') || 'text';
        var position = $target.attr('data-thha-tooltip-position') || 'top-center';
        var animation = $target.attr('data-thha-tooltip-animation') || 'fade';
        var theme = $target.attr('data-thha-tooltip-theme') || 'dark';

        var content = '';
        if (contentType === 'image') {
          var imageUrl = $target.attr('data-thha-tooltip-image');
          if (imageUrl) {
            content = '<img src="' + imageUrl + '" alt="tooltip image" />';
          }
        } else {
          content = $target.attr('data-thha-tooltip-content') || '';
        }

        if (!content) return null;

        var $tooltip = $('<div class="thha-advanced-tooltip thha-tooltip-theme-' + theme + ' thha-tooltip-anim-' + animation + '" data-position="' + position + '">' +
          '<div class="thha-tooltip-content">' + content + '</div>' +
          '<div class="thha-tooltip-arrow"></div>' +
          '</div>');

        // Apply custom variables if custom theme
        if (theme === 'custom') {
          var bg = $target.attr('data-thha-tooltip-bg') || '#7351fd';
          var color = $target.attr('data-thha-tooltip-color') || '#ffffff';
          var arrowColor = $target.attr('data-thha-tooltip-arrow-color') || bg;
          var padding = $target.attr('data-thha-tooltip-padding') || '10px';
          var radius = $target.attr('data-thha-tooltip-radius') || '8px';
          var width = $target.attr('data-thha-tooltip-width') || '200px';

          $tooltip.css({
            '--thha-tooltip-bg': bg,
            '--thha-tooltip-color': color,
            '--thha-tooltip-arrow-color': arrowColor,
            '--thha-tooltip-padding': padding,
            '--thha-tooltip-radius': radius,
            '--thha-tooltip-width': width
          });
        }

        return $tooltip;
      }

      function show() {
        if (activeTooltip) return;

        var $tooltip = createTooltip();
        if (!$tooltip) return;

        $('body').append($tooltip);
        activeTooltip = $tooltip;

        var offsetX = parseInt($target.attr('data-thha-tooltip-offset-x'), 10) || 0;
        var offsetY = parseInt($target.attr('data-thha-tooltip-offset-y'), 10) || 0;
        var position = $target.attr('data-thha-tooltip-position') || 'top-center';

        positionTooltip($target, $tooltip, position, offsetX, offsetY);

        // Trigger reflow to ensure CSS animations play
        $tooltip[0].offsetHeight;

        $tooltip.addClass('is-active');
      }

      function hide() {
        if (!activeTooltip) return;
        var $el = activeTooltip;
        activeTooltip = null;

        $el.removeClass('is-active');
        
        // Wait for CSS transition to finish before removing from DOM
        setTimeout(function () {
          $el.remove();
        }, 300);
      }

      if (trigger === 'hover') {
        $target.on('mouseenter.thhaTooltip', function () {
          show();
        }).on('mouseleave.thhaTooltip', function () {
          hide();
        });
      } else if (trigger === 'click') {
        $target.on('click.thhaTooltip', function (e) {
          e.stopPropagation();
          if (activeTooltip) {
            hide();
          } else {
            show();
          }
        });

        // Click outside handler
        $(document).on('click.thhaTooltipOutside-' + $target.attr('data-id'), function (e) {
          if (activeTooltip && !$(e.target).closest($target).length && !$(e.target).closest(activeTooltip).length) {
            hide();
          }
        });
      }
    });
  }

  function positionTooltip($target, $tooltip, position, offsetX, offsetY) {
    var targetOffset = $target.offset();
    var targetWidth = $target.outerWidth();
    var targetHeight = $target.outerHeight();
    var tooltipWidth = $tooltip.outerWidth();
    var tooltipHeight = $tooltip.outerHeight();

    var top = 0;
    var left = 0;

    switch (position) {
      case 'top-left':
        top = targetOffset.top - tooltipHeight;
        left = targetOffset.left;
        break;
      case 'top-center':
        top = targetOffset.top - tooltipHeight;
        left = targetOffset.left + (targetWidth / 2) - (tooltipWidth / 2);
        break;
      case 'top-right':
        top = targetOffset.top - tooltipHeight;
        left = targetOffset.left + targetWidth - tooltipWidth;
        break;
      case 'bottom-left':
        top = targetOffset.top + targetHeight;
        left = targetOffset.left;
        break;
      case 'bottom-center':
        top = targetOffset.top + targetHeight;
        left = targetOffset.left + (targetWidth / 2) - (tooltipWidth / 2);
        break;
      case 'bottom-right':
        top = targetOffset.top + targetHeight;
        left = targetOffset.left + targetWidth - tooltipWidth;
        break;
      case 'left-top':
        top = targetOffset.top;
        left = targetOffset.left - tooltipWidth;
        break;
      case 'left-center':
        top = targetOffset.top + (targetHeight / 2) - (tooltipHeight / 2);
        left = targetOffset.left - tooltipWidth;
        break;
      case 'left-bottom':
        top = targetOffset.top + targetHeight - tooltipHeight;
        left = targetOffset.left - tooltipWidth;
        break;
      case 'right-top':
        top = targetOffset.top;
        left = targetOffset.left + targetWidth;
        break;
      case 'right-center':
        top = targetOffset.top + (targetHeight / 2) - (tooltipHeight / 2);
        left = targetOffset.left + targetWidth;
        break;
      case 'right-bottom':
        top = targetOffset.top + targetHeight - tooltipHeight;
        left = targetOffset.left + targetWidth;
        break;
    }

    // Add manual offsets
    top += offsetY;
    left += offsetX;

    // Viewport collision checking & adjustments
    var windowWidth = $(window).width();
    var scrollLeft = $(window).scrollLeft();
    if (left < scrollLeft) {
      left = scrollLeft + 5;
    } else if (left + tooltipWidth > scrollLeft + windowWidth) {
      left = scrollLeft + windowWidth - tooltipWidth - 5;
    }

    $tooltip.css({
      top: top + 'px',
      left: left + 'px'
    });
  }

  // Initial load
  initTooltip();

  // Elementor edit mode support
  if (window.elementorFrontend) {
    window.elementorFrontend.hooks.addAction('frontend/element_ready/global', function ($scope) {
      initTooltip($scope);
    });
  }
});
